export default {
  name: { is: 'Nafn', en: 'Name' },
  kennitala: { is: 'Kennitala', en: 'Id. No.' },
  email: { is: 'Netfang', en: 'Email address' },
  phonenumer: { is: 'Sími', en: 'Phone number' },

  withSpouse: {
    is: 'Ég mæti með maka',
    en: 'I will bring my spouse',
  },
  continue: {
    is: 'Áfram',
    en: 'Continue',
  },

  spouseName: { is: 'Nafn maka', en: 'Name of spouse' },
  spouseKennitala: { is: 'Kennitala maka', en: 'Id. No. of spouse' },
  spouseEmail: { is: 'Netfang maka', en: 'Email address of spouse' },
  spousePhonenumer: { is: 'Sími maka', en: 'Phone number of spuse' },

  kennitalaNotFound: { is: 'Kennitala finnst ekki í þjóðskrá' },
};
